import { render } from "./EditAdd.vue?vue&type=template&id=05265997&scoped=true"
import script from "./EditAdd.vue?vue&type=script&lang=js"
export * from "./EditAdd.vue?vue&type=script&lang=js"

import "./EditAdd.vue?vue&type=style&index=0&id=05265997&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05265997"]])

export default __exports__